import { createSlice, PayloadAction } from '@reduxjs/toolkit'
// import { useCookie } from '@/utils/util'
// const { value: token, setValue: setToken, remove: removeToken } = useCookie('token');
interface UserInfo {
  accessToken: string,
  authorization: string
  roleCode: string
  username: string
}


const initialState: UserInfo = {
  accessToken: '',
  roleCode: '',
  authorization: '',
  username: ''
}

const userInfo = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserState: (state, action: PayloadAction<UserInfo>) => { // 设置具体值
      state.accessToken = action.payload.accessToken
      state.authorization = action.payload.authorization
      state.roleCode = action.payload.roleCode
      state.username = action.payload.username

    },
    clearTokens: (state) => {
      state.accessToken = ''
      state.authorization = ''
      state.roleCode = ''
      state.username = ''
      // 同时清除本地存储的 token
    }

  },
})

export const { setUserState, clearTokens } = userInfo.actions
export default userInfo.reducer
